import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarLabelIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-label"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#EBEDEE" rx={4} />
            <path
                stroke="#48505E"
                strokeWidth={1.5}
                d="M22.75 7.75c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v4.95a1.95 1.95 0 0 1-.57 1.38l-8.1 8.099a1.95 1.95 0 0 1-2.759.001l-4.5-4.5a1.95 1.95 0 0 1-.001-2.76l8.1-8.1a1.95 1.95 0 0 1 1.38-.57h4.95z"
                className="decoration"
            />
            <path fill="#48505E" fillRule="nonzero" d="M21 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </g>
    </svg>
);
const Memo = memo(ToolbarLabelIcon);
export default Memo;
